import React, { useContext, useEffect, useState } from 'react';
import '../../App.css'
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import {useLocation} from 'react-router-dom';
import Container from '@mui/material/Container';
import Layout from '../../component/Layout';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputMask from 'react-input-mask';
import Alert from '@mui/material/Alert'
import apiCep from '../../utilities/Cep';

import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import icoSwitchOn from '../../assets/icoSwitchOn.png'
import icoSwitchOff from '../../assets/icoSwitchOff.png'

export function CriarVistoria() {
    const location = useLocation()
    const [userData, setUserData] = useContext(UserProfile)
    const [systemData, setSystemData] = useContext(SystemProfile)
    const [step, setStep] = useState(1)

    const [companies, setCompanies] = useState([])
    const [company, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState([])
    const [nrs, setNrs] = useState([])
    const [selectedNr, setSelectedNr] = useState([])
    const [modeloVistoria, setModeloVistoria] = useState([])
    const [vistoriadores, setVistoriadores] = useState([])
    const [vistoriador, setVistoriador] = useState([])

    const id = Date.parse(new Date())
    const [prioridade, setPrioridade] = useState(false)
    const [timeVistoria, setTimeVistoria] = useState()
    const [dataHora, setDataHora] = useState()
    const [tipoVistoria, setTipoVistoria] = useState(0)
    const [dossie, setDossie] = useState()
    const [empreend, setEmpreend] = useState()
    const [codEmpreend, setCodEmpreend] = useState()
    const [addressStreet, setAddressStreet] = useState()
    const [addressNum, setAddressNum] = useState()
    const [addressPlus, setAddressPlus] = useState()
    const [addressBairro, setAddressBairro] = useState()
    const [addressCidade, setAddressCidade] = useState()
    const [addressCEP, setAddressCEP] = useState('')
    const [addressUF, setAddressUF] = useState()
    const [addressPais, setAddressPais] = useState()
    const [obs, setObs] = useState()
    const [alert, setAlert] = useState(false)
    const [hover, setHover] = useState(false)
    const [mountedNrs, setMountedNrs] = useState([])
    const [finalNrs, setFinalNrs] = useState([])
    const [team, setTeam] = useState([])
    const [finalTeam, setFinalTeam] = useState([])
    const [allUsers, setAllUsers] = useState(false)

    const [day, setDay] = useState();
    const [month, setMonth] = useState()
    const [year, setYear] = useState()
    

    const [concluido, setConcluido] = useState(false)

    async function BuscaCep() {
    try {
        const newCep = addressCEP.replace(/-/g, '');
        const response = await apiCep.get(`/${newCep}/json/`)
        setAddressStreet(response.data.logradouro)
        setAddressBairro(response.data.bairro)
        setAddressCidade(response.data.localidade)
        setAddressUF(response.data.uf)
        setAddressPais(response.data.pais)
    }catch(error){
        console.log('error: +'+error)
    }
}

    useEffect(()=>{
        if(addressCEP.length >= 7){
            BuscaCep()
        }
    }, [addressCEP])

    useEffect(()=>{
        let s = new Date(month+'/'+day+'/'+year)
        setDataHora(s)
    }, [day, month, year])

    const dataVistoria = {
        id: id,
        step: 1,
        stepLabel: 'Informações Pricipais',
        company: company.length != 0 ? company[0] : null,
        nomeFantasia: company.length != 0 ? company[1] : '',
        nomeVistoriador: vistoriador.length != 0 ? vistoriador[1] : 'sem nome',
        vistoriador: vistoriador.length != 0 ? vistoriador[0] : 'null@null',
        modeloVistoria: modeloVistoria.length != 0 ? modeloVistoria[0] : null,
        dossie: dossie,
        empreend: empreend,
        codEmpreend: codEmpreend,
        type: tipoVistoria,
        status: 'naoiniciada',
        dataHora: new Date(),
        prioridade: prioridade,
        addressStreet: addressStreet,
        addressNum: addressNum,
        addressPlus: addressPlus,
        addressBairro: addressBairro,
        addressCidade: addressCidade,
        addressCEP: addressCEP,
        addressUF: addressUF,
        addressPais: addressPais,
        obs: obs,
        data: [],
        ocorrencias: [],
        equipe: finalTeam,
        notificacoes: [],
        startVistoria: new Date(),
        finalVistoria: null,
        nrs: finalNrs
    }


    const headers = {
        headers: {
          "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
          "Authorization": `Bearer ${userData.token}`
        }};
    
    const dataTecnicos = {
        companyId: company
    }   

    async function GetUsers() {
        api.post('auth/getUsers/', dataTecnicos, headers).then(response => {
        setVistoriadores((response.data).filter(user => user.role === 'tecnico' || user.role === 'admin' || userData.companyId === company[0]))
        }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
        })
    }
    
    /* async function GetUsers() {
        api.get('auth/getUsers/', headers).then(response => {
        setVistoriadores((response.data).filter(user => user.role === 'tecnico'))
        }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
        })
    }
    */
    
    async function GetCompanies() {
        api.get('company/getCompanies/', headers).then(response => {
        setCompanies(response.data)
        }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
        })
    }
    
    async function GetCompany() {
        api.post('company/getCompany', {cnpj: company[0]}, headers).then(response => {
        setSelectedCompany(response.data)
        console.log(response.data)
        }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
        })
    }

    useEffect(()=>{
        if(selectedCompany.length != 0){
            setAddressStreet(selectedCompany.rua)
            setAddressNum(selectedCompany.numero)
            setAddressPlus(selectedCompany.compl)
            setAddressBairro(selectedCompany.bairro)
            setAddressCidade(selectedCompany.cidade)
            setAddressUF(selectedCompany.uf)
            setAddressCEP(selectedCompany.cep)
        }}, [selectedCompany])

        
    async function GetNrs() {
      await api.get('nr/getNrs/', headers).then(response => {
        setNrs(response.data)
        GetCompanies()
      }).catch(error => {
        setSystemData({...systemData, erro: error.message, errorType: 'warning'})
      })
    }

    useEffect(()=>{
        GetTeam()
    }, [allUsers])

    const dataTeam = {
        companyId: allUsers ? null : company[0]
    }
    async function GetTeam(){
        await api.post('auth/getTeam', dataTeam, headers).then(result => {
            setTeam(result.data)
        }).catch(error => {
            setSystemData({...systemData, erro: error.message, errorType: 'warning'})
        })
    }

    function CreateFinalTeam(username, role, name, step) {
        if(finalTeam.some(mail => mail.username === username)) {
            setFinalTeam(oldValues => {
            return oldValues.filter(item => item.username !== username);
            });
        } else {
            setFinalTeam(current => [...current, {username: username, role: role, name: name}])
        }
    }

    useEffect(()=>{
      GetNrs()
    }, [])


    async function SaveVistoria() {
            if(empreend != undefined && tipoVistoria != undefined && dataHora != undefined && addressStreet != undefined && addressNum != undefined && addressBairro != undefined && addressCidade != undefined && addressCEP != undefined && addressUF != undefined){
                await api.post('vistoria/createVistoria', dataVistoria, headers).then((response => {
                    setConcluido(true)
                    setStep(0)
                    console.log(response.data)
                }))
                .catch(() => {
                    setSystemData({...systemData, error: 'Algo não ocorreu conforme o esperado. Tente novamente mais tarde', errorType: 'error'})
                })
            } else {
                setAlert(true)
            }
    }
    
    useEffect(()=>{
        if(modeloVistoria[0] != undefined){
            GetCompanies()
            setStep(2)
        }
    }, [modeloVistoria])

    useEffect(()=>{
        if(company[0] != undefined) {
            GetUsers()
            setStep(3)
        }
    }, [company])

    useEffect(()=>{
        if(company.length > 0){
            GetTeam()
        }
    }, [company])

    useEffect(()=>{
        if(vistoriador[0] != undefined) {
            setStep(4)
        }
    }, [vistoriador])


    function AddNr(value) {
        if(selectedNr.includes(value)) {
            selectedNr.filter(item => item === value)
            setHover(!hover)
        } else {
            selectedNr.push(value)
            setHover(!hover)
        }
    }

    const dataNr = {
        numbers: selectedNr
    }

    async function mountNrs(){
        api.post('nr/getNr/', dataNr, headers).then(response => {
        setMountedNrs(response.data)
        setStep(2)
            }).catch(error => {
                setSystemData({...systemData, erro: error.message, errorType: 'warning'})
            })
    }


    const addStatusToDocuments = (mountedNrs) => {
        return mountedNrs.map((item) => ({
          ...item,
          items: item.items.map((documento) => ({
            ...documento,
            status: "novo",
            conforme: "",
            na: "",
            naoconforme:[]
          })),
        }));
      };

    useEffect(()=>{
        if(mountedNrs.length > 0){
            const updatedData = addStatusToDocuments(mountedNrs)
            setFinalNrs(updatedData)
        }
    }, [mountedNrs])


    return(
        <>
            <Layout breadcrumb='Dashboard / Inspeção / Criar inspeção' title='Criar Inspeção'>
            <div style={{marginBlock: 10, marginBottom: 10, fontWeight: 600, fontSize: 20, color: '#ff6400'}}>Nova inspeção ID: {id}</div>
            <div style={{marginBlock: 10, marginBottom: 20}}>Siga os passos abaixo para criar a nova inspeção</div>
            {step === 1 ? <div style={{marginBlock: 10, marginBottom: 20, fontWeight: 'bold'}}>Selecione as Normas Regulamentadoras pertinentes a essa inspeção</div> : null}
                <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', margin: 10}}>
                    
                    {step === 1 ?
                        <>
                            {nrs?.map((nr, index)=>(
                                <Button variant='outlined' size='small' key={index} style={selectedNr.includes(nr.number) ? styles.nrHover : styles.nr} onClick={()=>{AddNr(nr.number)}}>
                                    NR {nr.number}
                                </Button>
                            ))}
                        </>

                    : null }
                </div>
                {step === 1 ?<Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{mountNrs()}}>
                                        Continuar
                                    </Button>
                    : null}

                {step === 2 ?
                    <>

                         <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }}>
                            <InputLabel id="empresa">Selecione uma Empresa</InputLabel>
                            <Select 
                                labelId="empresa"
                                label="Selecione uma empresa"
                                value={company}
                                onChange={(event) => setCompany(event.target.value)}>
                                {companies.length != 0 ? companies.map((item, index) => (
                                    <MenuItem key={index} value={[item.cnpj, item.nomeFantasia]}>{item.nomeFantasia}</MenuItem>
                                )) : null}
                            </Select>
                        </FormControl>
                        
                    </>
                    : null }

                {step === 3 ?
                    <>
                        <div style={{display: 'flex', flexDirection: 'column', marginBottom: 20}}>
                            <div><b>Normas Regulamentadoras:</b> {modeloVistoria[1]}</div>
                            <div><b>Empresa:</b> {company[1]}</div>
                            <div><b>CNPJ:</b> {company[0]}</div>
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column'}}>
                            <div style={{marginBottom: 10, fontWeight: 'bold'}}>Selecione um ou mais técnicos: </div>
                            {vistoriadores?.map((item, index) => (
                                <button onClick={()=>{CreateFinalTeam(item.username, item.role, item.name, 4)}} key={index} style={{margin: 10, borderRadius: 6, cursor: 'pointer', padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', backgroundColor: '#ffffff', border: 'none', fontSize: 14}}>
                                    <img src={finalTeam.some(mail => mail.username === item.username) ? icoSwitchOn : icoSwitchOff} style={{width: 25, marginRight: 20}} />
                                    <div style={{width: 200, alignItems: 'flex-start', textAlign: 'left'}}><strong>Nome:</strong> {item.name}</div>
                                </button>
                            ))}
                        </div>
                        <Button onClick={()=>{setStep(4)}}>
                            Continue
                        </Button>
                    </>   
                : null}

                {step === 4 ? 
                    <div>
                        <div style={{display: 'flex', flexDirection: 'column', marginBottom: 20}}>
                            <div><b>Normas Regulamentadoras:</b> {modeloVistoria[1]}</div>
                            <div><b>Empresa:</b> {company[1]}</div>
                            <div><b>CNPJ:</b> {company[0]}</div>
                            <div><b>Técnico(s): </b> {finalTeam?.map((name, index)=>(<div style={{marginLeft: 20}}>{name.name} - {name.username}</div>))}</div>
                            <div style={{display: 'flex', flexDirection: 'column', flexWrap: 'wrap', marginBottom: 20, marginTop: 30}}>
                            <div>
                                <b>NRs relacionadas:</b>
                                <div style={{ display: 'flex', flexDirection: 'row', width: 700, flexWrap: 'wrap'}}>
                                    {selectedNr.map((nr, index)=>(
                                        <span style={styles.nrInterno}>
                                            NR {nr}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                        </div>
                        <div style={{marginBottom: 10, fontSize: 14}}>
                            <b>Selecione os usuários a serem notificados</b>
                            <Button variant='outlined' disableElevation size='small' onClick={()=>{setAllUsers(!allUsers)}} style={{marginLeft: 20}}>
                                {allUsers ? 'Mostrar apenas os usuários do CNPJ' : 'Mostrar todos os usuários'}
                            </Button>
                        </div>
                        <div>


                            {team.filter(item => item.role != 'tecnico' || item.role != 'admin').map((user, index) => (
                                <button onClick={()=>{CreateFinalTeam(user.username, user.role, user.name)}} key={index} style={{margin: 10, borderRadius: 6, cursor: 'pointer', padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', backgroundColor: '#ffffff', border: 'none', fontSize: 14}}>
                                    <img src={finalTeam.some(mail => mail.username === user.username) ? icoSwitchOn : icoSwitchOff} style={{width: 25, marginRight: 20}} />
                                    <div style={{width: 200, alignItems: 'flex-start', textAlign: 'left'}}><strong>Nome:</strong> {user.name}</div>
                                    <div style={{width: 160, textAlign: 'left'}}><strong>Função:</strong> {user.role}</div>
                                    <div><strong>Email:</strong> {user.username}</div>
                                </button>
                            ))}
                            
                            
                        </div>
                        
                        <div>

                        </div>
                        <div>
                            <div>
                                <div style={{marginBlock: 20}}>Preencha as informações necessárias para a criação da Inspeção:</div>
                                <Button variant="contained" disableElevation size='large' onClick={()=>{GetCompany()}}>
                                    Buscar dados do CNPJ {company[0]}
                                </Button>
                            </div>
                            
                            <div style={{marginBlock: 20, display: 'flex', flexDirection: 'column'}}>
                                <>
                                <div style={styles.item}>
                                    <FormControl fullWidth>
                                    <TextField onChange={(event) => setEmpreend(event.target.value)} value={empreend} label="Nome do empreendimento / obra / setor *" variant="outlined" style={styles.item} />

                                <div style={{marginBlock: 20}}>Localização da vistoria</div>
                                <div>
                                    <InputMask
                                        mask="99999-999"
                                        value={addressCEP}
                                        onChange={(event) => setAddressCEP(event.target.value)}
                                        disabled={false}
                                        maskChar=" "
                                    >
                                        {() => <TextField label="CEP *" variant="outlined" style={styles.itemPeq} />}
                                    </InputMask> 
                                    <TextField onChange={(event) => setAddressStreet(event.target.value)} value={addressStreet} placeholder="Rua, avenida, logradouro, etc... *" variant="outlined" style={styles.itemMed} />
                                    <TextField onChange={(event) => setAddressNum(event.target.value)} value={addressNum} label="Número *" variant="outlined" style={styles.itemPeq} />
                                    <TextField onChange={(event) => setAddressPlus(event.target.value)} value={addressPlus} label="Complemento" variant="outlined" style={styles.itemPeq} />
                                </div>
                                <TextField onChange={(event) => setAddressBairro(event.target.value)} value={addressBairro} placeholder="Bairro *" variant="outlined" style={styles.item} />
                                <TextField onChange={(event) => setAddressCidade(event.target.value)} value={addressCidade} placeholder="Cidade *" variant="outlined" style={styles.item} />
                                <div>
                                     
                                    <TextField onChange={(event) => setAddressUF(event.target.value)} value={addressUF} placeholder="UF *" variant="outlined" style={styles.itemPeq} />
                                    <TextField onChange={(event) => setAddressPais(event.target.value)} value={addressPais ? addressPais : 'Brasil'} label="País" variant="outlined" style={styles.itemMed} />
                                    <TextField onChange={(event) => setObs(event.target.value)} fullWidth multiline rows={4} value={obs} label="Observações adicionais" variant="outlined" style={styles.item} />
                                </div>
                                <div>* campos obrigatórios</div>
                                
                                {alert ? <div style={{marginBlock: 5}}><Alert severity='error'>Prrencha todos os campos obrigatórios</Alert></div> : <></> }
                                <Button variant="contained" disableElevation size='large' onClick={()=>{SaveVistoria()}}>
                                    Salvar e Iniciar Inspeção
                                </Button>
                                </FormControl>
                                </div>
                                </>
                            </div>
                        </div>
                    </div>
                : 
                concluido ?    
                <div style={{fontSize: 14, fontWeight: 600}}>
                    Inspeção {id} criada e atribuída com sucesso.
                </div>
                : null 
                }

            </Layout>
        </>
    )
}

const styles = {
    item: {
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    itemPeq: {
        width: 100,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    itemMed: {
        width: 400,
        marginTop: 5,
        marginLeft: 5,
        marginRight: 5,
        marginBottom: 5,
    },
    nr: {
        margin: 10,
        backgroundColor: '#ffffff',
        borderRadius: 8,
        padding: 5,
        borderWidth: 1,
        borderColor: '#ececec',
        width: 60,
        alignItems: 'center'
    },
    nrHover: {
        margin: 10,
        backgroundColor: '#f5894d',
        borderRadius: 8,
        padding: 5,
        color: '#ffffff',
        borderWidth: 1,
        borderColor: '#f5894d',
        width: 60,
        alignItems: 'center'
    },
    nrInterno: {
        textAlign: 'center', 
        fontSize: 11,
        marginRight: 5,
        marginTop: 10,
        backgroundColor: '#ffffff',
        borderRadius: 8,
        padding: 5,
        borderWidth: 1,
        borderColor: '#ececec',
        width: 60,
        alignItems: 'center'
    }
}
